module.exports = __webpack_public_path__ + "static/img/coo_2.cdd0232.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coo_2.png
// module id = zTx2
// module chunks = 1